<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <Case/>
    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Case from '@/components/Case'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Case,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/case-banner.jpg"),
        title: "闻道有先后 术业有专攻",
        sub: "心怀匠人之心 努力将每一个产品塑造成行业典范"
      }
    }
  }
}
</script>

<style scoped lang="less">
.a{
  .b{
    font-size: 30px;
  }
}
</style>
